export const balancesList = [
    {
        value:1,
        label:'充值'
    },
    {
        value:2,
        label:'使用'
    },
    {
        value:3,
        label:'退回'
    },
]